<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

      <div title>
        <h1>
          <span *ngIf="newMode()">{{ t('common.labels.create_recommendation') }}</span>
          <span *ngIf="editMode()">{{ t('common.labels.recommendation') }} <strong>{{ recommendation.getLang('name', transloco.getActiveLang()) }}</strong></span>
        </h1>
      </div>

      <div details>
        <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

            <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
              <app-recommendation-new *ngIf="newMode()"></app-recommendation-new>
              <app-recommendation-basedata *ngIf="editMode()" [recommendation]="recommendation" (setEdit)="setEdit($event)"></app-recommendation-basedata>
            </p-tabPanel>

        </p-tabView>
      </div>

    </app-detail-view>
</ng-container>
